export const SEARCH_ROLES = 'app/user_management/search_roles';
export const SEARCH_ALL_ROLES = 'app/user_management/search_all_roles';
export const SEARCH_ROLES_SUCCESS = 'app/user_management/search_roles_success';
export const SEARCH_ROLES_FAILURE = 'app/user_management/search_roles_failure';
export const SET_PARAMS_ROLES = 'app/user_management/set_params_roles';

export const GET_ROLES_BY_ID = 'app/user_management/get_role_by_id';
export const GET_ROLES_BY_ID_SUCCESS = 'app/user_management/get_role_by_id_success';
export const GET_ROLES_BY_ID_FAILURE = 'app/user_management/get_role_by_id_failure';

export const MODIFY_ROLE = 'app/user_management/modify_role';
export const CREATE_ROLE = 'app/user_management/create_role';
export const SEARCH_ROLE_GROUPS = 'app/user_management/search_role_groups';
export const SEARCH_ALL_ROLE_GROUPS = 'app/user_management/search_all_role_groups';
export const SEARCH_ROLE_GROUPS_SUCCESS = 'app/user_management/search_role_groups_success';
export const SEARCH_ROLE_GROUPS_FAILURE = 'app/user_management/search_role_groups_failure';
export const SET_PARAMS_ROLE_GROUPS = 'app/user_management/set_params_role_groups';
export const GET_ROLE_GROUP_BY_ID = 'app/user_management/get_role_group_by_id';
export const MODIFY_ROLE_GROUP = 'app/user_management/modify_role_group';
export const CREATE_ROLE_GROUP = 'app/user_management/create_role_group';

export const SEARCH_USERS = 'app/user_management/search_users';
export const SEARCH_USERS_SUCCESS = 'app/user_management/search_users_success';
export const SEARCH_USERS_FAILURE = 'app/user_management/search_users_failure';
export const SET_PARAMS_LIST_USERS = 'app/user_management/set_params_list_users';

export const GET_USER_BY_ID = 'app/user_management/get_user_by_id';
export const GET_USER_BY_ID_SUCCESS = 'app/user_management/get_user_by_id_success';
export const GET_USER_BY_ID_FAILURE = 'app/user_management/get_user_by_id_failure';
export const MODIFY_USER = 'app/user_management/modify_user';
export const CREATE_USER = 'app/user_management/create_user';

export const GET_USER_GROUPS = 'app/user_management/GET_USER_GROUPS';
export const GET_USER_GROUPS_SUCCESS = 'app/user_management/GET_USER_GROUPS_SUCCESS';
export const MODIFY_USER_GROUPS = 'app/user_management/MODIFY_USER_GROUPS';
export const CREATE_USER_GROUPS = 'app/user_management/CREATE_USER_GROUPS';

export const GET_APPROVAL = 'app/user_management/GET_APPROVAL';
export const MODIFY_APPROVAL = 'app/user_management/MODIFY_APPROVAL';
export const CREATE_APPROVAL = 'app/user_management/CREATE_APPROVAL';
export const SEARCH_USER_GROUPS = 'app/user_management/SEARCH_USER_GROUPS';